module.exports = {"description":"","displayName":"NavDropdown","methods":[],"props":{"children":{"type":{"name":"node"},"required":false,"description":"Dropdown content (NavItems)","defaultValue":{"value":"undefined","computed":true}},"className":{"type":{"name":"string"},"required":false,"description":"CSS class name","defaultValue":{"value":"undefined","computed":true}},"cssMap":{"type":{"name":"objectOf","value":{"name":"string"}},"required":false,"description":"CSS class map","defaultValue":{"value":"styles","computed":true}}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/NavDropdown-props.json
// module id = 445
// module chunks = 0